import React, { useState } from "react";
import "./ZipAreaText.scss";

export const VISIBLE_ZIPS = 2;

export const zipsOf = (list) =>
  (Array.isArray(list?.zipCode) ? list.zipCode : [])
    .map((zip) => String(zip?.zipCode ?? zip ?? "").trim())
    .filter(Boolean);

const ZipAreaText = ({ list, fallback = "" }) => {
  const [open, setOpen] = useState(false);
  const zips = zipsOf(list);
  if (zips.length <= VISIBLE_ZIPS) return fallback;
  const shown = open ? zips : zips.slice(0, VISIBLE_ZIPS);
  const hidden = zips.length - VISIBLE_ZIPS;
  return (
    <span className="zip-area">
      Within ZIP(s) code {shown.join(", ")}{" "}
      <button
        type="button"
        className="zip-area__toggle"
        aria-expanded={open}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setOpen((value) => !value);
        }}
      >
        {open ? "Show less" : `+${hidden} more`}
      </button>
    </span>
  );
};

export default ZipAreaText;
